import {makeStyles} from "tss-react/mui";
import {Box, Breadcrumbs, ButtonProps, Typography} from "@mui/material";
import {IEntity} from "@buildwitt/shapeshift-types";
import {EntityIdentifier} from "@buildwitt/shapeshift-types/entityService";
import AddIcon from "@mui/icons-material/Add";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import {Link} from "react-router-dom";

const useStyles = makeStyles()((theme) => ({
	header: {
		display: "flex",
		flexDirection: "column"
		// justifyContent: "space-between"
	},
	title: {
		fontSize: "34px",
		lineHeight: 1.24
	},
	newTitle: {
		lineHeight: 1.24,
		textTransform: "capitalize",
		fontSize: "34px"
	},
	subtitle: {
		fontWeight: 400,
		fontSize: "16px"
	},
	breadcrumbs: {
		".MuiBreadcrumbs-li": {
			display: "flex",
			flexDirection: "row",
			alignItems: "center"
		},
		".MuiSvgIcon-root": {
			fontSize: "1.1em",
			marginRight: theme.spacing(0.5)
		}
	},
	titleContainer: {
		display: "flex",
		flexDirection: "row",
		gap: theme.spacing(1),
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(4)
	},
	draft: {
		padding: theme.spacing(0.75, 1.25),
		borderRadius: "100px",
		color: theme.palette.primary.main,
		border: `1px solid ${theme.palette.primary.main}`
	},
	published: {
		padding: theme.spacing(0.75, 1.25),
		borderRadius: "100px",
		backgroundColor: theme.palette.success.main
	},
	statusContainer: {
		marginLeft: "auto",
		flexShrink: 0
	}
}));

export interface IProps<T extends IEntity & {title?: string}, K extends EntityIdentifier> {
	title: string,
	subtitle: string,
	actionButtons?: (null | ({label: string, loading?: boolean} & Omit<ButtonProps, "label" | "children">))[],
	editMode: "edit" | "create",
	entity?: T,
	type?: K,
	rootBreadcrumb: JSX.Element,
	rootSlug: string,
	isPublished?: boolean
}

export const AdminHeader = <T extends IEntity & {title?: string}, K extends EntityIdentifier>({rootBreadcrumb, editMode, entity, type, rootSlug}: IProps<T, K>): JSX.Element => {
	const {classes} = useStyles();
	const isPublished = !!entity && !!entity.publishedAt

	return (
		<Box className={classes.header}>
			<Breadcrumbs className={classes.breadcrumbs} separator="/" aria-label="breadcrumb">
				{rootBreadcrumb}
				{editMode === "create" ? (<>
					<AddIcon />
					<Typography>Create New</Typography>
				</>) : entity ? <>
					{type === "course" ? <DescriptionOutlinedIcon /> : <PlayArrowIcon />}
					<Link to={`${rootSlug}/${entity?.id}`}><Typography>{entity?.title}</Typography></Link>
				</> : null}
			</Breadcrumbs>
			<Box className={classes.titleContainer}>
				<Box>
					{editMode === "create" ? <>
						<Typography variant="h4" className={classes.newTitle}>{`Create New ${type}`}</Typography>
					</> : <>
						<Typography variant="h4" className={classes.title}>{entity?.title}</Typography>
					</>}
				</Box>
				{editMode === "edit" && entity ? <Box className={classes.statusContainer}>
					{isPublished ? <Typography variant="small" className={classes.published}>Published</Typography> : <Typography variant="small" className={classes.draft}>Draft</Typography>}
				</Box> : null}
			</Box>
		</Box>
	);
}
